import React, { useState, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import Info from '@material-ui/icons/Info';
import Grid from '@material-ui/core/Grid';
import { Tooltip } from "@material-ui/core";
import Accordion from '@material-ui/core/ExpansionPanel';
import AccordionSummary from '@material-ui/core/ExpansionPanelSummary';
import AccordionDetails from '@material-ui/core/ExpansionPanelDetails';

import injectReducer from '../../utils/injectReducer';
import injectSaga from '../../utils/injectSagas';

import orgReducer from '../../reducers/organizationManagement';
import { createStructuredSelector } from 'reselect';
import orgSaga from '../../sagas/organizationManagement';
import networkReducer from '../../reducers/networkDiscovery';
import networkSaga from '../../sagas/networkDiscovery';

import { connect } from 'react-redux';
import { compose } from 'redux';

import { actions as AppActions, selectInformaCastEnabled } from '../../reducers/app';
import { actions as OrganizationManagementAction, types as OrganizationManagementTypes } from '../../reducers/organizationManagement';

import InformaCastForm from './orgManagementComponents/InformaCastForm';
import IntegrationCredForm from './orgManagementComponents/IntegrationCredForm';
import MyE911UserWelcomeEmailFeature from './orgManagementComponents/MyE911UserWelcomeEmailFeature';
import UserWelcomeEmailFeature from './orgManagementComponents/UserWelcomeEmailFeature';
import MyE911ClientSoftwareUpdatesFeature from './orgManagementComponents/MyE911ClientSoftwareUpdatesFeature';
import UseDIDforFallBackRoutingOfHELDFeature from './orgManagementComponents/UseDIDforFallBackRoutingOfHELDFeature';
import BypassMSTeamsManualLocationVerification from './orgManagementComponents/BypassMSTeamsManualLocationVerification';
import AllowStickyIPNetworkElementMappingToLocations from './orgManagementComponents/AllowStickyIPNetworkElementMappingToLocations';
import NetworkDataAutoCreationFeature from './orgManagementComponents/NetworkDataAutoCreationFeature';
import MyE911DisableInformationalNotificationsFeature from './orgManagementComponents/MyE911DisableInformationalNotificationsFeature';
import CleanUpInactiveDevicesFeature from './orgManagementComponents/CleanUpInactiveDevicesFeature';
import SingleSignOnSettings from './orgManagementComponents/SingleSignOnSettings';
import { currentCompanyOrgType, orgTypes } from '../../reducers/auth';
import LicensingServiceApi from '../../apis/licensingServiceApi';
import { selectUserCompany, selectUserRole } from "../../reducers/auth";
import IpRangeList from '../../containers/IpRangeList/ipRangeList';
import './OrganizationManagementPage.css';

function OrganizationManagementPage(props) {
    const company = props.company.toJS();

    const user = JSON.parse(sessionStorage.getItem('__permifyUser'));

    const isViewNetworkDiscovery = user && user.permissions.includes('VIEW_NETWORK_DISCOVERY');
    const isEditNetworkDiscovery = user && user.permissions.includes('EDIT_NETWORK_DISCOVERY');
    
    const isViewAlertSubscriptions = user && user.permissions.includes('VIEW_ALERT_SUBSCRIPTIONS');
    const isEditAlertSubscriptions = user && user.permissions.includes('EDIT_ALERT_SUBSCRIPTIONS');

    const isViewMy911Client = user && user.permissions.includes('VIEW_MYE911_CLIENT_OPTIONS');
    const isEditMy911Client = user && user.permissions.includes('EDIT_MYE911_CLIENT_OPTIONS');
    
    const isViewRoutingOptions = user && user.permissions.includes('VIEW_ROUTING_OPTIONS');
    const isEditRoutingOptions = user && user.permissions.includes('EDIT_ROUTING_OPTIONS');

    const isViewSso = user && user.permissions.includes('VIEW_SSO');
    const isEditSso = user && user.permissions.includes('EDIT_SSO');
    
    const isViewAlertTemplates = user && user.permissions.includes('VIEW_ALERT_TEMPLATES');
    const isEditAlertTemplates = user && user.permissions.includes('EDIT_ALERT_TEMPLATES');

    const isViewHeldDevices = user && user.permissions.includes('VIEW_HELD_DEVICES');
    const isDeleteHeldDevices = user && user.permissions.includes('DELETE_HELD_DEVICES');
    
    const isViewDeviceUsers = user && user.permissions.includes('VIEW_DEVICE_USERS');
    const isDeleteDeviceUsers = user && user.permissions.includes('DELETE_DEVICE_USERS');

    const [enhanced_Notification, setEnhanced_Notification] = useState(false);

    function modalHandleOpen() {
        props.setCurrentModal(OrganizationManagementTypes.ADD_CER_SERVERS);
    }

    useEffect(() => {
        props.setPageTitle('Organization Management');
        props.setPageTitleId('organization-management-header');

        if (props.currentCompanyOrgType !== orgTypes.CURRENT_COMPANY_ORG_TYPE_SYSTEM) {
            LicensingServiceApi.checkIfOrgHasLicense(company.id).then(response => {
                setEnhanced_Notification(response.data)
            });
        }
    }, []);

    const [expandedPanel2, setExpandedPanel2] = useState(false);
    const [expandedPanel3, setExpandedPanel3] = useState(false);
    const [expandedPanel4, setExpandedPanel4] = useState(false);
    const [expandedPanel5, setExpandedPanel5] = useState(false);
    const [expandedPanel6, setExpandedPanel6] = useState(false);
    const [expandedPanel7, setExpandedPanel7] = useState(false);
    const [expandedPanel8, setExpandedPanel8] = useState(false);
    const [expandedPanel9, setExpandedPanel9] = useState(false);
    const [expandedPanel10, setExpandedPanel10] = useState(false);
    const [expandedPanel11, setExpandedPanel11] = useState(false);
    
    const handleChangePanel = (panel) => (event, newExpanded) => {
        switch (panel) {
            case 'panel2':
                setExpandedPanel2(newExpanded ? panel : false);
                break;
            case 'panel3':
                setExpandedPanel3(newExpanded ? panel : false);
                break;
            case 'panel4':
                setExpandedPanel4(newExpanded ? panel : false);
                break;
            case 'panel5':
                setExpandedPanel5(newExpanded ? panel : false);
                break;
            case 'panel6':
                setExpandedPanel6(newExpanded ? panel : false);
                break;
            case 'panel7':
                setExpandedPanel7(newExpanded ? panel : false);
                break;
            case 'panel8':
                setExpandedPanel8(newExpanded ? panel : false);
                break;
            case 'panel9':
                setExpandedPanel9(newExpanded ? panel : false);
                break;
            case 'panel10':
                setExpandedPanel10(newExpanded ? panel : false);
                break;
            case 'panel11':
                setExpandedPanel11(newExpanded ? panel : false);
                break;
            default:
                break;
        }
    };

    return (
        <div className="organization-management-section">
            {(props.currentCompanyOrgType === orgTypes.CUSTOMER && isViewNetworkDiscovery)  && 
                <Accordion style={{ marginBottom: 80 }} expanded={expandedPanel2 === 'panel2'} onChange={handleChangePanel('panel2')}>
                    <AccordionSummary
                        expandIcon={<div aria-label="HELD / HELD+ / MyE911 Corporate Network Elements Options" className="triangle-icon"></div>}
                        aria-controls="panel2-content"
                        id="panel2-header"
                        style={{ background: sessionStorage.getItem('skin') === 'five9' ? 'rgba(36, 76, 222, 1.0)' : '#1b536a', minHeight: 48, margin: 0 }}
                    >
                    <div htmlFor="panel2-header"
                         style={{ 
                            textAlign: 'center',
                            width: '100%',
                            padding: 0,
                            color: '#fff'
                    }}>HELD / HELD+ / MyE911 Corporate Network Elements Options</div>
                    <Tooltip 
                        title="Control whether corporate network elements are automatically added from HELD / HELD+ / MyE911 Request messages."
                        placement="top"
                    >
                        <span tabIndex={0} style={{ padding: 0 }}>
                            <Info style={{ color: '#fff' }} />
                        </span>
                    </Tooltip>
                    </AccordionSummary>
                    <AccordionDetails id="panel2-content" style={{ flexDirection: 'column' }}>
                        <NetworkDataAutoCreationFeature disableInput={(expandedPanel2 && isEditNetworkDiscovery)}/>
                    </AccordionDetails>
                </Accordion>
            }
            {(props.currentCompanyOrgType === orgTypes.CUSTOMER  && (isViewDeviceUsers || isViewHeldDevices))  && 
                <Accordion style={{ marginBottom: 80 }} expanded={expandedPanel3 === 'panel3'} onChange={handleChangePanel('panel3')}>
                    <AccordionSummary
                        expandIcon={<div aria-label="HELD / HELD+ / MyE911 Device Garbage Collection" className="triangle-icon"></div>}
                        aria-controls="panel3-content"
                        id="panel3-header"
                        style={{ background: sessionStorage.getItem('skin') === 'five9' ? 'rgba(36, 76, 222, 1.0)' : '#1b536a', minHeight: 48, margin: 0 }}
                    >
                    <div htmlFor="panel3-header"
                         style={{ 
                            textAlign: 'center',
                            width: '100%',
                            padding: 0,
                            color: '#fff'
                    }}>HELD / HELD+ / MyE911 Device Garbage Collection</div>
                    <Tooltip 
                        title="Define when and what inactive devices should be automatically deleted from the system."
                        placement="top"
                    >
                        <span tabIndex={0} style={{ padding: 0 }}>
                            <Info style={{ color: '#fff' }} />
                        </span>
                    </Tooltip>
                    </AccordionSummary>
                    <AccordionDetails id="panel3-content" style={{ flexDirection: 'column' }}>
                        <CleanUpInactiveDevicesFeature isViewDeviceUsers={isViewDeviceUsers} isViewHeldDevices={isViewHeldDevices} disableInput={expandedPanel3} disableDeviceUser={isDeleteDeviceUsers} disableHELD={isDeleteHeldDevices}/>
                    </AccordionDetails>
                </Accordion>
            }
            {(props.currentCompanyOrgType === orgTypes.CUSTOMER && isViewNetworkDiscovery)  && 
                <Accordion style={{ marginBottom: 80 }} expanded={expandedPanel4 === 'panel4'} onChange={handleChangePanel('panel4')}>
                    <AccordionSummary
                        expandIcon={<div aria-label="HELD+ &amp; MyE911 Device Mapping" className="triangle-icon"></div>}
                        aria-controls="panel4-content"
                        id="panel4-header"
                        style={{ background: sessionStorage.getItem('skin') === 'five9' ? 'rgba(36, 76, 222, 1.0)' : '#1b536a', minHeight: 48, margin: 0 }}
                    >
                    <div htmlFor="panel4-header"
                        style={{ 
                            textAlign: 'center',
                            width: '100%',
                            padding: 0,
                            color: '#fff'
                    }}>HELD+ &amp; MyE911 Device Mapping</div>
                    <Tooltip 
                        title="Control whether IPs from the devices of off-premises Users are mapped to the Locations they set."
                        placement="top"
                    >
                        <span tabIndex={0} style={{ padding: 0 }}>
                            <Info style={{ color: '#fff' }} />
                        </span>
                    </Tooltip>
                    </AccordionSummary>
                    <AccordionDetails id="panel4-content" style={{ flexDirection: 'column' }}>
                        <AllowStickyIPNetworkElementMappingToLocations disableInput={(expandedPanel4 && isEditNetworkDiscovery)}/>
                    </AccordionDetails>
                </Accordion>
            }
            {(enhanced_Notification && isViewAlertSubscriptions) && 
                <Accordion style={{ marginBottom: 80 }} expanded={expandedPanel5 === 'panel5'} onChange={handleChangePanel('panel5')}>
                    <AccordionSummary
                        expandIcon={<div aria-label="Incident Communications" className="triangle-icon"></div>}
                        aria-controls="panel5-content"
                        id="panel5-header"
                        style={{ background: sessionStorage.getItem('skin') === 'five9' ? 'rgba(36, 76, 222, 1.0)' : '#1b536a', minHeight: 48, margin: 0 }}
                    >
                        <div
                            htmlFor="panel5-header" 
                            style={{ 
                                textAlign: 'center',
                                width: '100%',
                                padding: 0,
                                color: '#fff'
                        }}>Incident Communications</div>
                        <Tooltip 
                            title="To complete integration with Incident Communications please provide the API access information requested below. Only valid API access information will be saved."
                            placement="top"
                        >
                            <span tabIndex={0} style={{ padding: 0 }}>
                                <Info style={{ color: '#fff' }} />
                            </span>
                        </Tooltip>
                    </AccordionSummary>
                    <AccordionDetails id="panel5-content" style={{ flexDirection: 'column' }}>
                        <IntegrationCredForm disableInput={(expandedPanel5 && isEditAlertSubscriptions)} />
                    </AccordionDetails>
                </Accordion>
            }
            {(props.informaCastEnabled && isViewAlertSubscriptions) && 
                <Accordion style={{ marginBottom: 80 }} expanded={expandedPanel6 === 'panel6'} onChange={handleChangePanel('panel6')}>
                    <AccordionSummary
                        expandIcon={<div aria-label="InformaCast 911 Alerting" className="triangle-icon"></div>}
                        aria-controls="panel6-content"
                        id="panel6-header"
                        style={{ background: sessionStorage.getItem('skin') === 'five9' ? 'rgba(36, 76, 222, 1.0)' : '#1b536a', minHeight: 48, margin: 0 }}
                    >
                        <div
                            htmlFor="panel6-header" 
                            style={{ 
                                textAlign: 'center',
                                width: '100%',
                                padding: 0,
                                color: '#fff'
                        }}>InformaCast 911 Alerting</div>
                        <Tooltip 
                            title="To complete integration with InformaCast please provide your InformaCast Access Token. Only valid access tokens will be saved."
                            placement="top"
                        >
                            <span tabIndex={0} style={{ padding: 0 }}>
                                <Info style={{ color: '#fff' }} />
                            </span>
                        </Tooltip>
                    </AccordionSummary>
                    <AccordionDetails id="panel6-content" style={{ flexDirection: 'column' }}>
                        <InformaCastForm disableInput={(expandedPanel6 && isEditAlertSubscriptions)} />
                    </AccordionDetails>
                </Accordion>
            }
            {(props.currentCompanyOrgType === orgTypes.CUSTOMER && isViewMy911Client)  && 
                <Accordion style={{ marginBottom: 80 }} expanded={expandedPanel7 === 'panel7'} onChange={handleChangePanel('panel7')}>
                    <AccordionSummary
                        expandIcon={<div aria-label="MyE911 Client Options" className="triangle-icon"></div>}
                        aria-controls="panel7-content"
                        id="panel7-header"
                        style={{ background: sessionStorage.getItem('skin') === 'five9' ? 'rgba(36, 76, 222, 1.0)' : '#1b536a', minHeight: 48, margin: 0 }}
                    >
                        <div htmlFor="panel7-header" style={{ textAlign: 'center', width: '100%', padding: 0, color: '#fff'}}>MyE911 Client Options</div>
                    </AccordionSummary>
                    <AccordionDetails id="panel7-content" style={{ flexDirection: 'column' }}>
                        <MyE911ClientSoftwareUpdatesFeature disableInput={(expandedPanel7 && isEditMy911Client)}/>
                        <MyE911DisableInformationalNotificationsFeature disableInput={(expandedPanel7 && isEditMy911Client)}/>
                    </AccordionDetails>
                </Accordion>
            }  
            {(props.currentCompanyOrgType === orgTypes.CUSTOMER && isViewNetworkDiscovery) && 
                <Accordion style={{ marginBottom: 80 }} expanded={expandedPanel8 === 'panel8'} onChange={handleChangePanel('panel8')}>
                    <AccordionSummary
                        expandIcon={<div aria-label="Public IP Ranges" className="triangle-icon"></div>}
                        aria-controls="panel8-content"
                        id="panel8-header"
                        style={{ background: sessionStorage.getItem('skin') === 'five9' ? 'rgba(36, 76, 222, 1.0)' : '#1b536a', minHeight: 48, margin: 0 }}
                    >
                    <div htmlFor="panel8-header"
                         style={{ 
                            textAlign: 'center',
                            width: '100%',
                            padding: 0,
                            color: '#fff'
                    }}>Public IP Ranges</div>
                    {/* <Tooltip 
                        title="Define when and what inactive devices should be automatically deleted from the system."
                        placement="top"
                    >
                        <span tabIndex={0} style={{ padding: 0 }}>
                            <Info style={{ color: '#fff' }} />
                        </span>
                    </Tooltip> */}
                    </AccordionSummary>
                    <AccordionDetails id="panel8-content" style={{ flexDirection: 'column' }}>
                        {expandedPanel8 ? <IpRangeList isPublic={true}/> : null}
                    </AccordionDetails>
                </Accordion>
            }
            {(props.currentCompanyOrgType === orgTypes.CUSTOMER && isViewRoutingOptions) && 
                <Accordion style={{ marginBottom: 80 }} expanded={expandedPanel9 === 'panel9'} onChange={handleChangePanel('panel9')}>
                    <AccordionSummary
                        expandIcon={<div aria-label="Routing Options" className="triangle-icon"></div>}
                        aria-controls="panel9-content"
                        id="panel9-header"
                        style={{ background: sessionStorage.getItem('skin') === 'five9' ? 'rgba(36, 76, 222, 1.0)' : '#1b536a', minHeight: 48, margin: 0 }}
                    >
                    <div htmlFor="panel9-header"
                         style={{ 
                            textAlign: 'center',
                            width: '100%',
                            padding: 0,
                            color: '#fff'
                    }}>Routing Options</div>
                    </AccordionSummary>
                    <AccordionDetails id="panel9-content" style={{ flexDirection: 'column' }}>
                        <UseDIDforFallBackRoutingOfHELDFeature disableInput={(expandedPanel9 && isEditRoutingOptions)}/>
                        <BypassMSTeamsManualLocationVerification disableInput={(expandedPanel9 && isEditRoutingOptions)}/>
                    </AccordionDetails>
                </Accordion>
            }
            {(isViewSso) && 
                <Accordion style={{ marginBottom: 80 }} expanded={expandedPanel10 === 'panel10'} onChange={handleChangePanel('panel10')}>
                    <AccordionSummary
                        expandIcon={<div aria-label="SAML 2.0 Single Sign-On Settings" className="triangle-icon"></div>}
                        aria-controls="panel10-content"
                        id="panel10-header"
                        style={{ background: sessionStorage.getItem('skin') === 'five9' ? 'rgba(36, 76, 222, 1.0)' : '#1b536a', minHeight: 48, margin: 0 }}
                    >
                    <div htmlFor="panel10-header"
                         style={{ 
                            textAlign: 'center',
                            width: '100%',
                            padding: 0,
                            color: '#fff'
                    }}>SAML 2.0 Single Sign-On Settings</div>
                    {/* <Tooltip 
                        title="Define when and what inactive devices should be automatically deleted from the system."
                        placement="top"
                    >
                        <span tabIndex={0} style={{ padding: 0 }}>
                            <Info style={{ color: '#fff' }} />
                        </span>
                    </Tooltip> */}
                    </AccordionSummary>
                    <AccordionDetails id="panel10-content" style={{ flexDirection: 'column' }}>
                        <SingleSignOnSettings disableInput={(expandedPanel10 && isEditSso)} company={company}/>
                    </AccordionDetails>
                </Accordion>
            }
            {((props.currentCompanyOrgType === orgTypes.CUSTOMER || props.currentCompanyOrgType === orgTypes.SERVICE_PROVIDER ||
                               props.currentCompanyOrgType === orgTypes.RESELLER) && isViewAlertTemplates) && <Accordion style={{ marginBottom: 80 }} expanded={expandedPanel11 === 'panel11'} onChange={handleChangePanel('panel11')}>
                    <AccordionSummary
                        expandIcon={<div aria-label="Welcome Emails" className="triangle-icon"></div>}
                        aria-controls="panel11-content"
                        id="panel11-header"
                        style={{ background: sessionStorage.getItem('skin') === 'five9' ? 'rgba(36, 76, 222, 1.0)' : '#1b536a', minHeight: 48, margin: 0 }}
                    >
                    <div htmlFor="panel11-header" 
                        style={{ 
                            textAlign: 'center',
                            width: '100%',
                            padding: 0,
                            color: '#fff'
                    }}>Welcome Emails</div>
                    <Tooltip 
                        title="Configure whether or not auto-generated welcome emails are sent.."
                        placement="top"
                    >
                        <span tabIndex={0} style={{ padding: 0 }}>
                            <Info style={{ color: '#fff' }} />
                        </span>
                    </Tooltip>
                    </AccordionSummary>
                    <AccordionDetails id="panel11-content" style={{ flexDirection: 'column' }}>
                    {props.currentCompanyOrgType === orgTypes.CUSTOMER &&
                        <MyE911UserWelcomeEmailFeature disableInput={(expandedPanel11 && isEditAlertTemplates)}/>
                    }
                        <UserWelcomeEmailFeature disableInput={(expandedPanel11 && isEditAlertTemplates)}/>
                    </AccordionDetails>
                </Accordion>
            }
        </div>
    );
}

const mapStateToProps = () => createStructuredSelector({
    informaCastEnabled: selectInformaCastEnabled(),
    currentCompanyOrgType: currentCompanyOrgType(),
    company: selectUserCompany(),
    userRole: selectUserRole()
});

const mapDispatchToProps = dispatch => {
    return { 
        setCurrentModal: (currentModal, data) => dispatch(AppActions.setCurrentModal(currentModal, data)),
        fetchOrganizationManagement: () => dispatch(OrganizationManagementAction.getOrganizationManagementRequest()),
        setPageTitle: data => dispatch(AppActions.setPageTitle(data)),
        setPageTitleId: data => dispatch(AppActions.setPageTitleId(data))
    }
};

const withReducerNet = injectReducer({ key: 'networkDiscovery', reducer:networkReducer });
const withSagaNet = injectSaga({ key: 'networkDiscovery', saga:networkSaga });
const withReducerOrg = injectReducer({ key: 'organizationManagement', reducer:orgReducer });
const withSagaOrg = injectSaga({ key: 'organizationManagement', saga:orgSaga });
const withConnect = connect(mapStateToProps,mapDispatchToProps);

export default compose(
    withReducerNet,
    withReducerOrg,
    withSagaOrg,
    withSagaNet,
    withConnect,
)(OrganizationManagementPage);